import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { ProblemDetails } from "../contexts/problemDetails/ProblemDetails";

type Props = {
  problem: ProblemDetails;
  onClose: () => void;
}

const ProblemDialog = ({ problem, onClose }: Props) => {
  return <Dialog title={problem.title} onClose={onClose} className="dialog-w800">
    <div>
      <p>{problem.detail}</p>
      {problem.errors && <pre>{JSON.stringify(problem.errors, null, 2)}</pre>}
      <small className="text-muted">
        {problem.instance && problem.instance + ' '} http-{problem.status}
      </small>
    </div>
    <DialogActionsBar>
      <Button onClick={onClose}>Okay</Button>
    </DialogActionsBar>
  </Dialog>;
}

export default ProblemDialog;